import loadable from '@loadable/component'

import { cookieAllowlist } from './config/cookie-allowlist'
import { localCrumbs } from './config/crumbs'
import filterConfig from './config/filter-config'
import { orderings } from './config/orderings'
import routesList from './routes-list'
import { sentenceCase } from './utils/string'

const Packages = loadable(() => import('./components/pages/packages'))

const localPageFields = (
  locality,
  localityFormattedName,
  connectionTypes = ['HOME'],
  scope = 'broadband',
  routeMatch = locality
) => ({
  path: routesList[routeMatch],
  slug: 'broadband-local',
  contentId: `broadband-local-${locality}`,
  crumbs: localCrumbs(locality),
  component: Packages,
  nonServiceabilityPage: true,
  scope,
  cookieAllowlist,
  exact: true,
  orderings,
  filterConfig: filterConfig(),
  listnames: (intent = 'provider_of_the_week') => ({
    p0: 'Broadband - Header Advert',
    p1: `Broadband - Ad - ${intent.toLowerCase()}`,
    p4: `Broadband - Ad - ${intent.toLowerCase()} - enhanced`,
    table: `Broadband - Our top 10 broadband packages for ${localityFormattedName}`
  }),
  helmet: {
    canonical: `https://www.uswitch.com/${scope}/local/${locality}/`
  },
  connectionTypes
})

const localPages = [
  {
    locality: 'london',
    embeddedEeveeEntityIds: {
      heroContent: '7pUhU1JRQdihheUhBKSQAg',
      modularPage: '5n5UmzZtNkjEwzCwiYoZ7k',
      author: '1iQj37f6RmSVdm0rCFpRCT'
    }
  },
  { locality: 'oxford' },
  { locality: 'aberdeen' },
  { locality: 'bristol' },
  { locality: 'edinburgh' },
  { locality: 'leeds' },
  { locality: 'belfast' },
  { locality: 'exeter' },
  { locality: 'nottingham' },
  { locality: 'norwich' },
  { locality: 'brighton' },
  { locality: 'cardiff' },
  { locality: 'glasgow' },
  { locality: 'manchester' }
]

const localRoutes = localPages.map(({ locality, embeddedEeveeEntityIds }) => ({
  pageId: 'broadband-local',
  locality,
  embeddedEeveeEntityIds,
  ...localPageFields(locality, sentenceCase(locality))
}))

export default localRoutes
